
<div class="container-fluid glb-popup">

  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  @if (formLoading) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block create-reservation-form">
      <div class="row">
        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-4">
            <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
              optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              placeholder="Select Property" (onChange)="fetchOwners($event)">
            </p-dropdown>
            <label for="Select Property">Select Property</label>
            @for (validation of validationMessages.shortTermRentalId; track validation) {
              <span>
                @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="reservationTypes" formControlName="reservationType" optionLabel="name"
            optionValue="value" placeholder="Type" (onChange)="fetchOwners($event)"></p-dropdown>
            <label for="reservationType">Reservation Type</label>
            @for (validation of validationMessages.reservationType; track validation) {
              <span>
                @if (form1.get('reservationType').hasError(validation.type) && (form1.get('reservationType').dirty || form1.get('reservationType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        @if (form1.get('shortTermRentalId').value && form1.get('reservationType').value && form1.get('reservationType').value == 1
          && owners.length > 1) {
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-4">
              <p-dropdown [options]="owners" formControlName="ownerProfileId" optionLabel="combinedLabel"
                optionValue="ownerProfileId" [filter]="true" filterBy="combinedLabel" [showClear]="false"
                placeholder="Select Owner" (onChange)="onOwnerChange($event)">
              </p-dropdown>
              <label for="Select Owner">Select Owner</label>
              @for (validation of validationMessages.ownerProfileId; track validation) {
                <span>
                  @if (form1.get('ownerProfileId').hasError(validation.type) && (form1.get('ownerProfileId').dirty || form1.get('ownerProfileId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-4">
            <!-- <p-calendar formControlName="checkInDate" inputId="checkInDate" appendTo="body">
          </p-calendar> -->
          <p-calendar #checkInDateCal class="error-bg" placeholder="Select Date" formControlName="checkInDate" appendTo="body"
            selectOtherMonths="true" inputId="checkInDate" [showTime]="false" dateMask (mouseup)="onKeyDate($event)"
            (onSelect)="checkInChange($event)" [minDate]="minDate" [maxDate]="maxDate" [readonlyInput]="false">
            <ng-template pTemplate="date" let-date>
              <span style="border-radius:50%; padding: .25em; width: 2em; height: 2em; display:block">{{date.day}}</span>
            </ng-template>
          </p-calendar>
          <label for="checkInDate">CheckIn Date</label>
          @for (validation of validationMessages.checkInDate; track validation) {
            <span>
              @if (form1.get('checkInDate').hasError(validation.type) && (form1.get('checkInDate').dirty || form1.get('checkInDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-4">
          <!-- <p-calendar formControlName="checkOutDate" inputId="checkOutDate" appendTo="body">
        </p-calendar> -->
        <p-calendar #checkOutDateCal class="error-bg" placeholder="Select Date" formControlName="checkOutDate" appendTo="body"
          selectOtherMonths="true" inputId="checkOutDate" [showTime]="false" (onClose)="openGuestModal($event)" dateMask
          (keyup)="compareDate($event)" (mouseup)="onKeyDateForCheckOutDate($event)" (onSelect)="checkOutChange($event)"
          selectOtherMonths="true" [defaultDate]="checkOutDateBasedOnCheckinDate"
          [minDate]="updatedCheckInDate" [maxDate]="maxDate" [readonlyInput]="false">
          <ng-template pTemplate="date" let-date>
            <span style="border-radius:50%; padding: .25em; width: 2em; height: 2em; display:block">{{date.day}}</span>
          </ng-template>
        </p-calendar>
        <label for="checkOutDate">CheckOut Date</label>
        @for (validation of validationMessages.checkOutDate; track validation) {
          <span>
            @if (form1.get('checkOutDate').hasError(validation.type) && (form1.get('checkOutDate').dirty || form1.get('checkOutDate').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6  mb-4">
      <span class="p-float-label w-100">
        <p-dropdown [options]="numAdults" formControlName="numAdults" optionLabel="name" optionValue="value"
        placeholder="Adults"></p-dropdown>
        <label for="numAdults">Adults</label>
        @for (validation of validationMessages.numAdults; track validation) {
          <span>
            @if (form1.get('numAdults').hasError(validation.type) && (form1.get('numAdults').dirty || form1.get('numAdults').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6  mb-4">
      <span class="p-float-label w-100">
        <p-dropdown [options]="childrens" formControlName="numChildren" optionLabel="name" optionValue="value"
        placeholder="Children"></p-dropdown>
        <label for="numChildren">Children</label>
        @for (validation of validationMessages.numChildren; track validation) {
          <span>
            @if (form1.get('numChildren').hasError(validation.type) && (form1.get('numChildren').dirty || form1.get('numChildren').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="p-0" formGroupName="guestProfile">
      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-4">
          <input formControlName="emailAddress" id="emailAddress" type="email" pInputText>
          <label for="emailAddress">Email Address</label>
          @for (validation of validationMessages.emailAddress; track validation) {
            <span>
              @if (form1.get('guestProfile.emailAddress').hasError(validation.type) && (form1.get('guestProfile.emailAddress').dirty || form1.get('guestProfile.emailAddress').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="row m-0">
        <div class="col-lg-6 mb-4">
          <span class="p-float-label required-field w-100">
            <input formControlName="firstName" id="firstName" type="text" pInputText>
            <label for="firstName">First Name</label>
            @for (validation of validationMessages.firstName; track validation) {
              <span>
                @if (form1.get('guestProfile.firstName').hasError(validation.type) && (form1.get('guestProfile.firstName').dirty || form1.get('guestProfile.firstName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6 mb-4">
          <span class="p-float-label required-field w-100">
            <input formControlName="lastName" id="lastName" type="text" pInputText>
            <label for="lastName">Last Name</label>
            @for (validation of validationMessages.lastName; track validation) {
              <span>
                @if (form1.get('guestProfile.lastName').hasError(validation.type) && (form1.get('guestProfile.lastName').dirty || form1.get('guestProfile.lastName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <span class="p-float-label w_122">
        <p-dropdown class="w-100" [options]="referralSources" formControlName="referralSourceId" optionLabel="name" appendTo="body"
        [filter]="true" filterBy="name" optionValue="value" placeholder=""></p-dropdown>
        <label for="Select Property">Referral Source</label>
        @for (validation of validationMessages.referralSourceId; track validation) {
          <span>
            @if (form1.get('referralSourceId').hasError(validation.type) && (form1.get('referralSourceId').dirty || form1.get('referralSourceId').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>




  <div class="col-lg-12">

  </div>

</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          <button pButton class="btn-addt p-button" (click)="createReservation()" [disabled]="readOnlySubmitBotton">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>